import { render, staticRenderFns } from "./assetRegister.vue?vue&type=template&id=59080f3e&scoped=true&"
import script from "./assetRegister.vue?vue&type=script&lang=js&"
export * from "./assetRegister.vue?vue&type=script&lang=js&"
import style0 from "./assetRegister.vue?vue&type=style&index=0&id=59080f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59080f3e",
  null
  
)

export default component.exports